import { FC, useState } from 'react';
import { Sketch } from '@uiw/react-color';
import { border1, exactWhite } from 'utils/style/colors';
import LocalIcon from 'ui/LocalIcon';
import styled from 'styled-components';
import APopover from 'components/APopover';

const SketchColorPickerContainer = styled.div``;

const SketchContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  gap: 0.5rem;
  background-color: ${exactWhite};
`;

const ColorPickerCircle = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  border: ${border1};
  cursor: pointer;
`;

interface IProps {
  onChangeLableColor: (color: string) => void;
  color?: string;
  isEnabled: boolean;
  disableColorPicker: () => void;
  openColorPicker: () => void;
}

const SketchColorPicker: FC<IProps> = ({
  color,
  onChangeLableColor,
  isEnabled,
  disableColorPicker,
  openColorPicker,
}) => {
  const [hex, setHex] = useState<string>(color ?? '#fff');

  return (
    <SketchColorPickerContainer>
      <APopover
        target={
          <div>
            <ColorPickerCircle
              color={color}
              onClick={(e: any) => {
                e.stopPropagation();
                openColorPicker();
              }}
            />
          </div>
        }
        trigger="click"
        show={isEnabled}
      >
        <SketchContainer>
          <LocalIcon
            iconName="close-square.svg"
            type="sm"
            color={'no-color'}
            onClick={(e) => {
              e.stopPropagation();
              disableColorPicker();
            }}
            isLink={true}
            style={{ alignSelf: 'flex-end' }}
          />
          <Sketch
            style={{}}
            color={hex}
            onChange={(color) => {
              setHex(color.hex);
              onChangeLableColor(color.hex);
            }}
          />
        </SketchContainer>
      </APopover>
    </SketchColorPickerContainer>
  );
};

export default SketchColorPicker;
